<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>Inbox</h3>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row v-show="certMail.length > 0">
            <v-col cols="12">
                <h4>Certificate Order Messages</h4>
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
                <v-data-table
                    :items="certMail"
                    :headers="certHeaders"
                    item-key="PortalInboxMailId">
                    <template v-slot:item.view="{item}">
                        <td><v-btn :icon="true" @click="redirectCert(item)"><v-icon dark>mdi-notebook-edit</v-icon></v-btn></td>
                    </template>
                    <template v-slot:item.modType="{item}"> <!--this error is a lie-->
                        <td>{{ modToString(item.modType) }}</td>
                    </template>
                    <template v-slot:item.messageType="{item}">
                        <td>{{ typeToString(item.messageType) }}</td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row v-show="mail.length > 0">
            <v-col cols="12">
                <h4>Verification Messages</h4>
                <v-divider></v-divider>
            </v-col>
            <v-col cols="12">
                <v-data-table
                    :items="mail"
                    :headers="headers"
                    item-key="PortalInboxMailId">
                    <template v-slot:item.view="{item}"> <!--this error is a lie-->
                        <td><v-btn :icon="true" @click="redirect(item)"><v-icon dark>mdi-notebook-edit</v-icon></v-btn></td>
                    </template>
                    <template v-slot:item.modType="{item}"> <!--this error is a lie-->
                        <td>{{ modToString(item.modType) }}</td>
                    </template>
                    <template v-slot:item.messageType="{item}">
                        <td>{{ typeToString(item.messageType) }}</td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row v-show="worksheets.length > 0">
            <v-col cols="12">
                <h4>Mother's Worksheets</h4>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row v-show="worksheets.length > 0">
            <v-col cols="12" >
                <v-data-table
                    :items="worksheets"
                    :headers="worksheetHeaders"
                    item-key="PortalMothersWorksheetId">
                    <template v-slot:item.view="{item}"> <!--this error is a lie-->
                        <td><v-btn :icon="true" @click="redirectMothersWorksheet(item)"><v-icon dark>mdi-notebook-edit</v-icon></v-btn></td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row v-show="marriageWorksheets.length > 0">
            <v-col cols="12">
                <h4>Marriage Worksheet(s)</h4>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row v-show="marriageWorksheets.length > 0">
            <v-col cols="12" >
                <v-data-table
                    :items="marriageWorksheets"
                    :headers="marriageWorksheetHeaders"
                    item-key="MarriageWorksheetId">
                    <template #[`item.view`]="{ item }">
                        <td><v-btn :icon="true" @click="redirectMarriageWorksheet(item)"><v-icon dark>mdi-notebook-edit</v-icon></v-btn></td>
                    </template>
                    <template #[`item.void`]="{ item }">
                        <td><v-btn v-bind="item.void" v-if="item.statusDescription === 'New'" :icon="true" @click="voidMarriageWs(item.marriageWorksheetId)"><v-icon dark>mdi-delete</v-icon></v-btn></td>
                        <td><v-btn :disabled="true" v-bind="item.void" v-if="item.statusDescription !== 'New'" :icon="true"><v-icon dark>mdi-delete-off</v-icon></v-btn></td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row v-show="birthOrders.length > 0 || deathOrders.length > 0 || marriageOrders.length > 0 || divorceOrders.length > 0">
            <v-col cols="12">
                <h4>Certificate Orders</h4>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" v-show="birthOrders.length > 0">
                <h5>Birth</h5>
                <v-data-table
                    title="Birth"
                    :items="birthOrders"
                    :headers="birthOrderHeaders"
                    item-key="PortalBirthOrderId"
                    :item-class="itemTextColor"
                >
                    <template #[`item.view`]="{ item }">
                        <td><v-btn v-bind="item.view" :icon="true" @click="redirectBirthOrder(item)"><v-icon dark>mdi-notebook-edit</v-icon></v-btn></td>
                    </template>
                    <template #[`item.void`]="{ item }">
                        <td><v-btn v-bind="item.void" v-if="item.portalBirthStatusId === 1" :icon="true" @click="voidOrder(item.portalBirthOrderId, item.modType)"><v-icon dark>mdi-delete</v-icon></v-btn></td>
                        <td><v-btn :disabled="true" v-bind="item.void" v-if="item.portalBirthStatusId !== 1" :icon="true"><v-icon dark>mdi-delete-off</v-icon></v-btn></td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" v-show="deathOrders.length > 0">
                <h5>Death</h5>
                <v-data-table
                    title="Death"
                    :items="deathOrders"
                    :headers="deathOrderHeaders"
                    item-key="PortalDeathOrderId"
                    :item-class="itemTextColor"
                >
                    <template #[`item.view`]="{ item }">
                        <td><v-btn v-bind="item.view" :icon="true" @click="redirectDeathOrder(item)"><v-icon dark>mdi-notebook-edit</v-icon></v-btn></td>
                    </template>
                    <template #[`item.void`]="{ item }">
                        <td><v-btn v-bind="item.void" v-if="item.portalDeathStatusId === 1" :icon="true" @click="voidOrder(item.portalDeathOrderId, item.modType)"><v-icon dark>mdi-delete</v-icon></v-btn></td>
                        <td><v-btn :disabled="true" v-bind="item.void" v-if="item.portalDeathStatusId !== 1" :icon="true"><v-icon dark>mdi-delete-off</v-icon></v-btn></td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" v-show="marriageOrders.length > 0">
                <h5>Marriage</h5>
                <v-data-table
                    title="Marriage"
                    :items="marriageOrders"
                    :headers="marriageDivorceOrderHeaders"
                    item-key="PortalMarriageDivorceOrderId"
                    :item-class="itemTextColor"
                >
                    <template #[`item.view`]="{ item }">
                        <td><v-btn v-bind="item.view" :icon="true" @click="redirectMarriageOrder(item)"><v-icon dark>mdi-notebook-edit</v-icon></v-btn></td>
                    </template>
                    <template #[`item.void`]="{ item }">
                        <td><v-btn v-bind="item.void" v-if="item.portalMarriageDivorceStatusId === 1" :icon="true" @click="voidOrder(item.portalMarriageDivorceOrderId, item.modType)"><v-icon dark>mdi-delete</v-icon></v-btn></td>
                        <td><v-btn :disabled="true" v-bind="item.void" v-if="item.portalMarriageDivorceStatusId !== 1" :icon="true"><v-icon dark>mdi-delete-off</v-icon></v-btn></td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" v-show="divorceOrders.length > 0">
                <h5>Divorce</h5>
                <v-data-table
                    title="Divorce"
                    :items="divorceOrders"
                    :headers="marriageDivorceOrderHeaders"
                    item-key="PortalMarriageDivorceOrderId"
                    :item-class="itemTextColor"
                >
                    <template #[`item.view`]="{ item }">
                        <td><v-btn v-bind="item.view" :icon="true" @click="redirectDivorceOrder(item)"><v-icon dark>mdi-notebook-edit</v-icon></v-btn></td>
                    </template>
                    <template #[`item.void`]="{ item }">
                        <td><v-btn v-bind="item.void" v-if="item.portalMarriageDivorceStatusId === 1" :icon="true" @click="voidOrder(item.portalMarriageDivorceOrderId, item.modType)"><v-icon dark>mdi-delete</v-icon></v-btn></td>
                        <td><v-btn :disabled="true" v-bind="item.void" v-if="item.portalMarriageDivorceStatusId !== 1" :icon="true"><v-icon dark>mdi-delete-off</v-icon></v-btn></td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import mailService from '@/services/mailService.js'
import mothersWorksheetService from '@/services/mothersWorksheetService'
import marriageWorksheetService from '@/services/marriageWorksheetService'
import certificateService from '@/services/certificateService'
import userService from '@/services/userService'
export default {
    components: {
    },
    data: () => {
        return {
            mail: [],
            isLoading: false,
            headers: [
                { text: 'View', value: 'view' },
                { text: 'Received', value: 'sentDate' },
                { text: 'Request ID', value: 'requestId' },
                { text: 'Last Name(s)', value: 'subMessage' },
                { text: 'Verification Type', value: 'modType' },
                { text: 'Message Type', value: 'messageType' }
            ],
            certMail: [],
            certHeaders: [
                { text: 'View', value: 'view' },
                { text: 'Received', value: 'sentDate' },
                { text: 'Certificate Order ID', value: 'subMessage' },
                { text: 'Cert Type', value: 'modType' },
                { text: 'Message Type', value: 'messageType' }
            ],
            worksheets: [],
            worksheetHeaders: [
                { text: 'View', value: 'view' },
                { text: 'Submitted', value: 'completedText' },
                { text: 'Worksheet ID', value: 'portalMothersWorksheetId' },
                { text: 'Child\'s First Name', value: 'childName.firstName' },
                // { text: 'Child\'s Middle Name', value: 'childName.middleName' },
                { text: 'Child\'s Last Name', value: 'childName.lastName' },
                { text: 'Mother\'s First Name', value: 'mothersLegalName.firstName' },
                // { text: 'Mother\'s Middle Name', value: 'mothersLegalName.middleName' },
                { text: 'Mother\'s Last Name', value: 'mothersLegalName.lastName' },
                { text: 'Mother\'s Date Of Birth', value: 'momDateOfBirth' },
                { text: 'Created Date', value: 'createdDate' }
            ],
            marriageWorksheets: [],
            marriageWorksheetHeaders: [
                { text: 'View', value: 'view' },
                { text: 'Status', value: 'statusDescription' },
                { text: 'ID', value: 'marriageWorksheetId' },
                { text: 'Applicant 1 First', value: 'applicant1First' },
                { text: 'Applicant 1 Last', value: 'applicant1Last' },
                { text: 'Applicant 2 First', value: 'applicant2First' },
                { text: 'Applicant 2 Last', value: 'applicant2Last' },
                { text: 'Delete', value: 'void' }
            ],
            birthOrders: [],
            birthOrderHeaders: [
                { text: 'View', value: 'view' },
                { text: 'Status', value: 'portalCertificateOrderStatus' },
                { text: 'Order ID', value: 'portalBirthOrderId' },
                { text: 'First Name', value: 'certFirstName' },
                { text: 'Middle Name', value: 'certMiddleName' },
                { text: 'Last Name', value: 'certLastName' },
                { text: 'Last Modified', value: 'modifyDate' },
                { text: 'Delete', value: 'void' }
            ],
            deathOrders: [],
            deathOrderHeaders: [
                { text: 'View', value: 'view' },
                { text: 'Status', value: 'portalCertificateOrderStatus' },
                { text: 'Order ID', value: 'portalDeathOrderId' },
                { text: 'First Name', value: 'certFirstName' },
                { text: 'Middle Name', value: 'certMiddleName' },
                { text: 'Last Name', value: 'certLastName' },
                { text: 'Last Modified', value: 'modifyDate' },
                { text: 'Delete', value: 'void' }
            ],
            marriageOrders: [],
            divorceOrders: [
                // { portalCertificateOrderStatusId: 0 }
            ],
            marriageDivorceOrderHeaders: [
                { text: 'View', value: 'view' },
                { text: 'Status', value: 'portalCertificateOrderStatus' },
                { text: 'Order ID', value: 'portalMarriageDivorceOrderId' },
                { text: 'First Name 1', value: 'firstName1' },
                { text: 'Middle Name 1', value: 'middleName1' },
                { text: 'Last Name 1', value: 'lastName1' },
                { text: 'First Name 2', value: 'firstName2' },
                { text: 'Middle Name 2', value: 'middleName2' },
                { text: 'Last Name 2', value: 'lastName2' },
                { text: 'Last Modified', value: 'modifyDate' },
                { text: 'Delete', value: 'void' }
            ]
        }
    },
    mounted: function () {
        mailService.getMail(this.$http).then(response => {
            /* eslint-disable-next-line */
            this.certMail = response.data.mail.filter(f => (f.messageType >= '5' && f.messageType <= '7') || f.messageType == '10')
            /* eslint-disable-next-line */
            this.mail = response.data.mail.filter(f => (f.messageType < '5' || f.messageType > '7') && f.messageType != '10')
        })
        if (userService.isPublicUser()) {
            mothersWorksheetService.getIncompleteWorksheets(this.$http).then(response => {
                this.worksheets = response.data.worksheets
            })
            this.loadCerts()
        }
        this.loadMarriageWorksheets()
        /*certificateService.getIncompleteBirthOrders(this.$http).then(response => {
            this.birthOrders = response.data
        })
        certificateService.getIncompleteDeathOrders(this.$http).then(response => {
            this.deathOrders = response.data
        })
        certificateService.getIncompleteMarriageDivorceOrders(this.$http).then(response => {
            this.marriageOrders = response.data.filter(x => x.modType == '20')
            this.divorceOrders = response.data.filter(x => x.modType == '30')
        })*/
    },
    methods: {
        loadCerts () {
            certificateService.getNewBirthOrders(this.$http).then(response => {
                this.birthOrders = response.data
            })
            certificateService.getNewDeathOrders(this.$http).then(response => {
                this.deathOrders = response.data
            })
            certificateService.getNewDivorceOrders(this.$http).then(response => {
                this.divorceOrders = response.data
            })
            certificateService.getNewMarriageOrders(this.$http).then(response => {
                this.marriageOrders = response.data
            })
        },
        loadMarriageWorksheets () {
            marriageWorksheetService.getMarriageWorksheets(this.$http).then(response => {
                this.marriageWorksheets = response.data
            })
        },
        modToString (modType) {
            switch (modType) {
            case '10':
            case 10: return 'Birth'
            case '20':
            case 20: return 'Marriage'
            case '30':
            case 30: return 'Divorce'
            case '40':
            case 40: return 'Death'
            }
        },
        typeToString (type) {
            switch (type) {
            case '0':
            case 0: return 'Correspondence'
            case '1':
            case 1: return 'Abstract Approved'
            case '2':
            case 2: return 'Abstract Denied'
            case '3':
            case 3: return 'Multiple Matches'
            case '4':
            case 4: return 'Unverified Issue'
            case '5':
            case 5: return 'Certificate Message'
            case '6':
            case 6: return 'Certificate Approved'
            case '7':
            case 7: return 'Certificate Denied'
            case '8':
            case 8: return 'Paternity Affidavit Approved'
            case '9':
            case 9: return 'Paternity Affidavit Denied'
            case '10':
            case 10: return 'Certificate Voided'
            }
        },
        redirect (item) {
            //console.log(item)
            this.$router.push('/inbox-details/' + item.portalInboxMailId + '/' + item.messageType)
        },
        redirectCert (item) {
            this.$router.push('/inbox-cert-details/' + item.portalInboxMailId)
        },
        redirectMothersWorksheet (item) {
            this.$router.push('/mothers-worksheet?worksheetId=' + item.portalMothersWorksheetId)
        },
        redirectMarriageWorksheet (item) {
            this.$router.push('/marriage-worksheet?marriageWsId=' + item.marriageWorksheetId)
        },
        redirectBirthOrder (item) {
            this.$router.push('/order-birth-certificate?orderId=' + item.portalBirthOrderId)
        },
        redirectDeathOrder (item) {
            this.$router.push('/order-death-certificate?orderId=' + item.portalDeathOrderId)
        },
        redirectMarriageOrder (item) {
            this.$router.push('/order-marriage-certificate?orderId=' + item.portalMarriageDivorceOrderId)
        },
        redirectDivorceOrder (item) {
            this.$router.push('/order-divorce-certificate?orderId=' + item.portalMarriageDivorceOrderId)
        },
        voidOrder (itemId, modType) {
            certificateService.voidOrder(this.$http, itemId, modType).then(response => {
                this.loadCerts()
            })
        },
        voidMarriageWs (itemId) {
            marriageWorksheetService.voidWs(this.$http, itemId).then(response => {
                this.loadMarriageWorksheets()
            })
        },
        itemTextColor (item) {
            return item.portalCertificateOrderStatus && item.portalCertificateOrderStatus.includes('More Information') ? 'red--text' : ''
        }
    }
}
</script>
